module.exports = __webpack_public_path__ + "img/ic_gear.fd8a85e6.svg";